import React, { Fragment, useState, useEffect, ReactElement } from 'react';
import Styles from './MedicalAppointment.module.scss';
import { Dependant, TableType, UserDataResponse, Relationship } from "../../store/medicalAppointment/types";
import PatientAppoitment from './PatientAppointment.SA';
import DependentData from './DependentData.SA';
import DynamicTable from '../../Tables/DynamicTable';
import calendar from '../../images/ImagesSA/ButtonIcon/calendar.png';
import plusBig from '../../images/ImagesSA/ButtonIcon/plusBig.png';
import data from '../../images/ImagesSA/ButtonIcon/data.png';
import { connect } from "react-redux";
import moment from 'moment';
import classnames from 'classnames';
import { getUserData, deleteUserDependant } from "../../store/medicalAppointment/thunks";
import { ApiResponse } from '../../services/types';
import { AppState } from '../../store';
import { MessageResponse } from '../../store/system/types';
import { ErrorComponent } from '../Labels/ErrorComponent';
import { ConvertValueParameter } from '../Parameters/ConvertValuesParameter';
import ButtonImage from '../Buttons/ButtonImage';
import { getToken } from '../User/Auth';
import { useHistory } from 'react-router-dom';
import MessagePopUp from '../ModalPopUp/MessagePopUp';
import { setMessageResponse } from "../../store/system/actions";

interface MedicalAppointmentProps {
    getUserData: any,
    errorMessage: MessageResponse | null,
    deleteUserDependant?: any
}

const MedicalAppointment: React.FC<MedicalAppointmentProps> = (props: MedicalAppointmentProps) => {
    const emptyDependant : Dependant = {
        birthdate: null,
        firstName : '',
        lastName : '',
        gender: '',
        identification: '',
        relationship : '',
        typeIdentification : ''
    };

    let displayDependant = "none";
    let history = useHistory();
    const [showingAppoitment, setshowingAppoitment] = useState(false);
    const [showingDependent, setshowingDependent] = useState(false);
    const [operationType, setOperationType] = useState("1");
    const [userDataResponse, setUserDataResponse] = useState<UserDataResponse>();
    const [currentDependant, setCurrentDependant] = useState<Dependant>(emptyDependant);
    const [errorMessage, setErrorMessage] = useState<ReactElement>(<Fragment></Fragment>);
    const [errorMessagePage, setErrorMessagePage] = useState<ReactElement>(<Fragment></Fragment>);
    const [showPopUp, setshowPopUp] = useState(false);
    const dataHeader: string[] = ["Tipo ID", "ID", "Nombres", "Apellidos", "Parentesco", "Género", "F. Nacimiento",""];

    useEffect(() => {
        if (props.errorMessage !== undefined)
        {
            setMessage(props.errorMessage?.message);
        }
    }, [props.errorMessage]);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        if (getToken() !== null) {
            const userDataResponse: ApiResponse = await props.getUserData();
            if (userDataResponse.StatusCode.toString() === "200") {
                setUserDataResponse(userDataResponse.Response);
            }
            else if (userDataResponse.StatusCode.toString() === "403" || userDataResponse.StatusCode.toString() === "500") {
                const serverMessage: string[] = userDataResponse.Error.status === 403 ?
                    ["Información no disponible"] :
                    [userDataResponse.Error.message]
                setMessageError(serverMessage);
                setshowPopUp(true);
            }
        }
        else {
            setMessageError(["Recurso inválido"]);
            setshowPopUp(true);
        }
    }

    const GenerarCeldaTabla = (val: TableType, cont: number, dependant: Dependant): ReactElement => {
        let td: ReactElement = cont < 7 ?
            <td>{ConvertValueParameter(val)}</td>
            :
            <Fragment>
                <td>{ConvertValueParameter(val)}</td>
                <td>
                    <div className={classnames("d-inline-block")}>
                        <button
                            id="btnEdit"
                            className={Styles.btnEdit}
                            onClick={() => openPopUpRequestDependent(dependant)}
                        />
                    </div>
                    <div className={classnames("d-inline-block")}>
                        <button
                            id="btnDelete"
                            className={Styles.btnDelete}
                            onClick={() => deleteDependant(dependant.identification)}
                        />
                    </div>
                </td>
            </Fragment>
        return td;
    }

    type DependantsType = ReactElement[] | undefined;
    const renderDependants = (): DependantsType => {
        return userDataResponse?.dependants?.map<ReactElement>((item) => {
            let cont = 0;
            return (
                <tr key={item.identification}>
                    {Object.values(item).map((val) => (
                        GenerarCeldaTabla(val, cont = cont + 1, item)
                    ))}
                </tr>
            )
        });
    }

    let patients = userDataResponse?.dependants?.slice();

    patients?.push({
        firstName: userDataResponse?.firstName? userDataResponse?.firstName : "",
        lastName: userDataResponse?.lastName? userDataResponse?.lastName : "",
        relationship: userDataResponse?.relationship ?
            userDataResponse.relationship.charAt(0).toUpperCase() + userDataResponse.relationship.slice(1) : "",
        typeIdentification: "",
        identification: userDataResponse?.identification ? userDataResponse?.identification : "",
        gender: "", birthdate: new Date()
    });

    if (showingDependent) {
        displayDependant = "block";
    }
    else {
        displayDependant = "none";
    }

    const openPopUpRequestDependent = (dependant: Dependant) => {
        setErrorMessage(<Fragment></Fragment>);
        if (dependant  !== emptyDependant) {
            setOperationType("2");
        }
        else {
            setOperationType("1");
        }
        setshowingDependent(true);
        setCurrentDependant(dependant);
    }

    const openPopUpRequest = (modal: string) => {
        setErrorMessage(<Fragment></Fragment>);
        if (modal === "appoitmemt") {
            setshowingAppoitment(true);
        }
    }
    const closePopUp = (modal: string) => {
        if (modal === "appoitmemt") {
            setshowingAppoitment(false);
        }
        else {
            setshowingDependent(false);
        }
    }

    const deleteDependant = async (identification: string) => {
        if (identification !== ""){
            const response = await props.deleteUserDependant(identification);
            if (response.StatusCode.toString() === "200") {
                loadData();
            }
        }
    }
    const setMessage = (message: string [] | undefined) => {
        setErrorMessage(
                        <ErrorComponent>
                        {message?.map((item) => {
                            return <p>{item}</p>
                        })}
                        </ErrorComponent>)
    }

     const setMessageError = (message: string [] | undefined) => {
        setErrorMessagePage(
                            <ErrorComponent>
                            {message?.map((item) => {
                                return <p>{item}</p>
                            })}
                            </ErrorComponent>)
    }

    const validatePartner = (identification: string): boolean => {
        const result: Dependant[] | undefined = userDataResponse?.dependants?.filter(item =>
            item.relationship === Relationship.Conyuge &&  item.identification !== identification);
        const exists = result === null || undefined ? 0 : result?.length;
        if (exists === 0 || exists === undefined) {
            return false;
        }
        else if (exists > 0) {
            return true;
        }
        return false;
    }

    const validateIdentification = (identification: string): boolean => {
         const result: Dependant[] | undefined = userDataResponse?.dependants?.filter(item =>
             item.identification === identification);
        const exists = result === null || undefined ? 0 : result?.length;
        if (exists === 0 || exists === undefined) {
            return false;
        }
        else if (exists > 0) {
            return true;
        }
        return false;
    }

    const showPopUpMessage = () => {
        setshowPopUp(false);
        setMessageResponse(null);
        history.push('/auth');
        history.go(0);
    }
    return (
        <div className={classnames(Styles.backGround, "row")}>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="container">
                    <div className="row mb-5 mt-5">
                        <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                            <table className={Styles.tdContent + " table"}>
                                <thead className={Styles.header}>
                                    <tr>
                                        <td colSpan={2}><h5 className={Styles.titleTable}>Datos del titular</h5></td>
                                    </tr>
                                </thead>
                                <tbody className="medium">
                                    <tr>
                                        <th>Cédula:</th>
                                        <td>{userDataResponse?.identification}</td>
                                    </tr>
                                    <tr>
                                        <th>Nombre:</th>
                                        <td>{userDataResponse?.firstName}</td>
                                    </tr>
                                    <tr>
                                        <th>Apellido:</th>
                                        <td>{userDataResponse?.lastName} </td>
                                    </tr>
                                    <tr>
                                        <th>Fecha de Nacimiento:</th>
                                        <td>{moment(userDataResponse?.birthdate).format("DD/MM/YYYY")} </td>
                                    </tr>
                                    <tr>
                                        <th>Género:</th>
                                        <td>{ConvertValueParameter(userDataResponse?.gender)} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                            <h5 className={Styles.title}>¿Qué necesitas?</h5>
                            <div className="row">
                                <div className={Styles.marginRow + " col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left"}>
                                    <sub className="small">Puedes agendar citas para ti y tus dependientes registrados. Si tu dependiente no
                                        está registrado puedes registrarlo ingresando a "Agregar dependientes"
                                    </sub>
                                </div>
                            </div>
                            <div className="row justify-content-center text-center mt-3">
                                <div className="col-lg-6 col-sm-12 col-md-12 col-xs-12 pt-1 mt-3">
                                    <ButtonImage
                                        id="btnPrevious"
                                        onClick={() => openPopUpRequest('appoitmemt')}
                                        styleClass="largetext"
                                        textoButton="Agendar cita"
                                        minWidth="20rem"
                                        maxWidth="20rem"
                                        align=""
                                        icon={<img src={calendar} className="img-fluid" alt="Agendar cita" />} />
                                </div>
                                <div className="col-lg-6 col-sm-12 col-md-12 col-xs-12 pt-1 mt-3">
                                    <ButtonImage
                                        id="btnNext"
                                        onClick={() => openPopUpRequestDependent(emptyDependant)}
                                        styleClass="largetext"
                                        textoButton="Agregar dependiente"
                                        minWidth="20rem"
                                        maxWidth="20rem"
                                        align=""
                                        icon={<img src={plusBig} className="img-fluid" alt="Agregar dependiente" />}/>
                                </div>
                                <div className="w-100"></div>
                                <div className="col-lg-6 col-sm-12 col-md-12 col-xs-12 pt-1 mt-3">
                                    <a href="https://public-assets-saludsa.s3.amazonaws.com/CONTRATOVIRTUALMENTEJUNTOSAPROBADO.pdf" target="_blank" rel="noopener noreferrer">
                                        <ButtonImage
                                            id="btnDatosContractuales"
                                            onClick=""
                                            styleClass="largetext"
                                            textoButton="Ver datos contractuales"
                                            minWidth="20rem"
                                            maxWidth="20rem"
                                            align=""
                                        icon={<img src={data} className="img-fluid" alt="Ver datos contractuales" />} />
                                    </a>
                                </div>
                                <div className="col-lg-6 col-sm-12 col-md-12 col-xs-12 pt-1"></div>
                            </div>
                            <div style={{ display: (showingAppoitment ? 'block' : 'none') }}>
                                <PatientAppoitment
                                    closePopUp={closePopUp}
                                    dependentList={patients}
                                    errorMessage={errorMessage}
                                    setMessage={setMessage}
                                />
                            </div>
                            <div style={{ display: displayDependant }}>
                                <DependentData
                                    closePopUp={closePopUp}
                                    loadData={loadData}
                                    dependant={currentDependant}
                                    operationType={operationType}
                                    validatePartner={validatePartner}
                                    validateIdentification={validateIdentification}
                                    errorMessage={errorMessage}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <DynamicTable
                                dataHeader={dataHeader}
                                headerTitle={
                                            <td
                                                className={classnames(Styles.header, "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left")}
                                                colSpan={8} >
                                                <h5 className={Styles.titleTable}> Mis dependientes
                                                </h5>
                                            </td>}>
                                <Fragment>
                                    {renderDependants()}
                                </Fragment>
                            </DynamicTable>
                        </div>
                    </div>
                    <div className="mt-3 text-center">
                       {errorMessage}
                    </div>
                    <div style={{ display: (showPopUp ? 'block' : 'none') }}>
                        <MessagePopUp
                            message={errorMessagePage}
                            buttonText="Aceptar"
                            showPopUpMessage={showPopUpMessage}
                            classNameStyle={classnames(Styles.error, "col-lg-8 col-md-8 col-sm-8 col-xs-8")}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: AppState) => ({
      errorMessage: state.system.messageResponse
});

export default connect(mapStateToProps, { getUserData: getUserData, deleteUserDependant, setMessageResponse })(MedicalAppointment);
